const $ = require('jquery')

// Bootstrap removes .open immediately, so retain the panel during fade-out.
module.exports = function bindNavbarTransitions (root) {
    const timers = new Map()
    const namespace = '.crmNavbarFade'
    const selector = '.x-navbar-dropdown'
    const clear = (element) => {
        clearTimeout(timers.get(element))
        timers.delete(element)
        $(element).removeClass('x-navbar-closing')
    }

    $(root).on('show.bs.dropdown' + namespace, selector, function () {
        clear(this)
    }).on('hide.bs.dropdown' + namespace, selector, function () {
        clear(this)
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
        $(this).addClass('x-navbar-closing')
        timers.set(this, setTimeout(() => clear(this), 160))
    })

    return () => {
        $(root).off(namespace)
        Array.from(timers.keys()).forEach(clear)
    }
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/components/ui/TopNavbar/transitions.js